import React, {Fragment, useEffect} from 'react'
import {Grow, Typography} from '@material-ui/core'

const Step2 = () => {
    useEffect(() => {
        const { localStorage } = window
        localStorage.clear()
    }, [])
    return (
        <Fragment>
            <Grow mountOnEnter in timeout={500}>
                <div>
                    <Typography
                        component="h5"
                        variant="h5"
                        gutterBottom
                        color="textPrimary">
                        Pré-cadastro finalizado!
                    </Typography>
                    <Typography
                        component="p"
                        variant="body1"
                        gutterBottom
                        color="textPrimary">
                        Pronto, agora é só aguardar o retorno da nossa equipe. Fique atento ao seu e-mail.
                    </Typography>
                </div>
            </Grow>
        </Fragment>
    );
};

export default Step2;
